import React, { useContext } from 'react';
import centroenlace from '../../img/centroenlace.jpg';
import AuthContext from '../../context/authentication/authContext';

function EvaluacionRealizada() {

    const authToken = useContext(AuthContext);
    const { user } = authToken;

    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="card card-small">
                            <div className="card-header border-bottom">
                                <h4 className="m-0">Evaluación Reunión Programa Mentoring – 2021</h4>
                            </div>
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item p-3">
                                    <div className="row">
                                        <div>
                                            <img src={centroenlace} className="logo-centro-enlace" alt="logo" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        
                                        <div className="col">
                                            <h3>La evaluación ya ha sido realizada</h3>
                                            { user.profile === 'Teacher' ? (
                                                <div>
                                                    <h4>Estimado Mentor,</h4>
                                                    <p>Le agradecemos responder la encuesta.<br/>Permanezca al tanto de la aplicación para saber si hay nuevas evaluaciones.<br/>Muchas gracias.<br/><br/><i>Equipo Centro de Enlace UC</i></p>
                                                </div>
                                            ) : (
                                                <div>
                                                    <h4>Estimado(a) Alumno(a),</h4>
                                                    <p>Te agradecemos responder la encuesta.<br/>Sigue al pendiente de la aplicación para saber si hay nuevas evaluaciones<br/>Muchas gracias.<br/><br/><i>Equipo Centro de Enlace UC</i></p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EvaluacionRealizada
